export const activities = [
  {
    id: 1,
    title: 'Lease near end',
    description: 'Your {assetName} is set for callback. Please make a choice',
    buttonText: 'Start',
    type: 'renew-device',
    date: '2024-12-24',
    asset: {
      id: 121546,
      asset_id: 121546,
      asset_description: 'Huawei MateBook X Pro 2020 bærbar PC',
      received: '2020-06-30T00:00:00+0200',
      imei_snr: '2019AP12263',
      type_id: 5,
      customer_id: 1,
      order_id: null,
      cost: 16792,
      injury_report_code: null,
      injury_report_status: null,
      age: 4,
      has_vat: null,
      buyout_details: null,
    },
  },
  {
    id: 1,
    title: 'Lease near end',
    description: 'Your {assetName} is set for callback. Please make a choice',
    buttonText: 'Start',
    type: 'renew-device',
    date: '2024-12-24',
    asset: {
      id: 124399,
      asset_id: 124399,
      asset_description: 'iPhone 15 Pro 5G 128GB Svart Titan',
      received: '2023-09-22T00:00:00+0200',
      imei_snr: '357627944993491',
      type_id: 2,
      customer_id: 1,
      order_id: null,
      cost: 12000,
      injury_report_code: 'kid89DbgGlVAJihdBd3nfPWi',
      injury_report_status: null,
      age: 1,
      has_vat: null,
      buyout_details: {
        id: 124399,
        description: 'iPhone 15 Pro 5G 128GB Svart Titan',
        img_url: null,
        is_asset_return_required: true,
        is_buyout_allowed: true,
        cost: 12000,
        age: 1,
        price_buyout: 7500,
        price_return: 0,
        is_buyout: false,
        is_return: false,
        policy_id: null,
      },
    },
  },
  // {
  //   id: 2,
  //   title: 'Return Device',
  //   description: 'Your {assetName} is set for return. Please return it to the IT Manager',
  //   buttonText: 'Start',
  //   type: 'return-device',
  //   date: '2024-12-24',
  //   asset: {
  //     id: 121546,
  //     asset_id: 121546,
  //     asset_description: 'Huawei MateBook X Pro 2020 bærbar PC',
  //     received: '2020-06-30T00:00:00+0200',
  //     imei_snr: '2019AP12263',
  //     type_id: 5,
  //     customer_id: 1,
  //     order_id: null,
  //     cost: 16792,
  //     injury_report_code: null,
  //     injury_report_status: null,
  //     age: 4,
  //     has_vat: null,
  //     buyout_details: null,
  //   },
  // },
]

export const assets = [
  {
    id: 121546,
    asset_id: 121546,
    asset_description: 'Huawei MateBook X Pro 2020 bærbar PC',
    received: '2020-06-30T00:00:00+0200',
    imei_snr: '2019AP12263',
    type_id: 5,
    customer_id: 1,
    order_id: null,
    cost: 16792,
    injury_report_code: null,
    injury_report_status: null,
    age: 4,
    has_vat: null,
    buyout_details: null,
  },
  {
    id: 124399,
    asset_id: 124399,
    asset_description: 'iPhone 15 Pro 5G 128GB Svart Titan',
    received: '2023-09-22T00:00:00+0200',
    imei_snr: '357627944993491',
    type_id: 2,
    customer_id: 1,
    order_id: null,
    cost: 12000,
    injury_report_code: 'kid89DbgGlVAJihdBd3nfPWi',
    injury_report_status: null,
    age: 1,
    has_vat: null,
    buyout_details: {
      id: 124399,
      description: 'iPhone 15 Pro 5G 128GB Svart Titan',
      img_url: null,
      is_asset_return_required: true,
      is_buyout_allowed: true,
      cost: 12000,
      age: 1,
      price_buyout: 7500,
      price_return: 0,
      is_buyout: false,
      is_return: false,
      policy_id: null,
    },
  },
  {
    id: 139900,
    asset_id: 139900,
    asset_description: 'Apple AirPods Pro 2nd gen (2023) helt trådløse hodetelefoner (USB-C)',
    received: '2023-12-19T00:00:00+0100',
    imei_snr: '',
    type_id: 13,
    customer_id: 1,
    order_id: null,
    cost: 2392,
    injury_report_code: 'K5Tvaqkijp8ddeHidabIhNlC',
    injury_report_status: 'PENDING_MANAGER',
    age: 0,
    has_vat: 0,
    buyout_details: null,
  },
  {
    id: 152779,
    asset_id: 152779,
    asset_description: 'Microsoft Surface Pro 9 for Business 13',
    received: '2024-01-18T00:00:00+0100',
    imei_snr: '0F38B3723443BF',
    type_id: 5,
    customer_id: 1,
    order_id: null,
    cost: 20999,
    injury_report_code: null,
    injury_report_status: null,
    age: 0,
    has_vat: null,
    buyout_details: null,
  },
  {
    id: 165139,
    asset_id: 165139,
    asset_description: 'Jabra Evolve2 65 L380a MS Stereo headset (sort)',
    received: '2024-06-26T00:00:00+0200',
    imei_snr: null,
    type_id: 13,
    customer_id: 1,
    order_id: null,
    cost: 1836,
    injury_report_code: null,
    injury_report_status: null,
    age: 0,
    has_vat: 0,
    buyout_details: null,
  },
]

export const myAssets = [
  {
    id: 1,
    name: 'iPhone 12',
    alias: 'iPhone 12',
    imgUrl:
      'https://acp-media.bluestonepim.com/5eba97c0-0f19-4ad4-9894-d14228c35fb0/63c6345d-ac1a-4531-81a9-93ce6e4d7cda/9CepXLrKIkxzJHOCav5XceaLS/syO3auyvYcDy25ORajwFdGD5S.png',
    inStock: 10,
    price: 4620,
    currency: 'NOK',
  },
  {
    id: 2,
    name: 'Samsung Galaxy S21',
    alias: 'Samsung Galaxy S21',
    imgUrl:
      'https://acp-media.bluestonepim.com/5eba97c0-0f19-4ad4-9894-d14228c35fb0/63c6345d-ac1a-4531-81a9-93ce6e4d7cda/9CepXLrKIkxzJHOCav5XceaLS/syO3auyvYcDy25ORajwFdGD5S.png',
    inStock: 15,
    price: 4620,
    currency: 'NOK',
  },
  {
    id: 3,
    name: 'Fairphone 4 128GB Grey',
    alias: 'Fairphone 4 128GB Grey',
    imgUrl:
      'https://acp-media.bluestonepim.com/5eba97c0-0f19-4ad4-9894-d14228c35fb0/63c6345d-ac1a-4531-81a9-93ce6e4d7cda/9CepXLrKIkxzJHOCav5XceaLS/syO3auyvYcDy25ORajwFdGD5S.png',
    inStock: 16,
    price: 4620,
    currency: 'NOK',
  },
  {
    id: 4,
    name: 'Fairphone 4 128GB Grey',
    alias: 'Fairphone 4 128GB Grey',
    imgUrl:
      'https://acp-media.bluestonepim.com/5eba97c0-0f19-4ad4-9894-d14228c35fb0/63c6345d-ac1a-4531-81a9-93ce6e4d7cda/9CepXLrKIkxzJHOCav5XceaLS/syO3auyvYcDy25ORajwFdGD5S.png',
    inStock: 18,
    price: 4620,
    currency: 'NOK',
  },
  {
    id: 5,
    name: 'Fairphone 4 128GB Grey',
    alias: 'Fairphone 4 128GB Grey',
    imgUrl:
      'https://acp-media.bluestonepim.com/5eba97c0-0f19-4ad4-9894-d14228c35fb0/63c6345d-ac1a-4531-81a9-93ce6e4d7cda/9CepXLrKIkxzJHOCav5XceaLS/syO3auyvYcDy25ORajwFdGD5S.png',
    inStock: 12,
    price: 4620,
    currency: 'NOK',
  },
]

export const newAssets = [
  {
    id: 1,
    name: 'iPhone 12',
    alias: 'iPhone 12',
    imgUrl:
      'https://acp-media.bluestonepim.com/5eba97c0-0f19-4ad4-9894-d14228c35fb0/63c6345d-ac1a-4531-81a9-93ce6e4d7cda/9CepXLrKIkxzJHOCav5XceaLS/syO3auyvYcDy25ORajwFdGD5S.png',
    inStock: 10,
    price: 4620,
    currency: 'NOK',
  },
  {
    id: 2,
    name: 'Samsung Galaxy S21',
    alias: 'Samsung Galaxy S21',
    imgUrl:
      'https://acp-media.bluestonepim.com/5eba97c0-0f19-4ad4-9894-d14228c35fb0/63c6345d-ac1a-4531-81a9-93ce6e4d7cda/9CepXLrKIkxzJHOCav5XceaLS/syO3auyvYcDy25ORajwFdGD5S.png',
    inStock: 15,
    price: 4620,
    currency: 'NOK',
  },
  {
    id: 3,
    name: 'Fairphone 4 128GB Grey',
    alias: 'Fairphone 4 128GB Grey',
    imgUrl:
      'https://acp-media.bluestonepim.com/5eba97c0-0f19-4ad4-9894-d14228c35fb0/63c6345d-ac1a-4531-81a9-93ce6e4d7cda/9CepXLrKIkxzJHOCav5XceaLS/syO3auyvYcDy25ORajwFdGD5S.png',
    inStock: 16,
    price: 4620,
    currency: 'NOK',
  },
  {
    id: 4,
    name: 'Fairphone 4 128GB Grey',
    alias: 'Fairphone 4 128GB Grey',
    imgUrl:
      'https://acp-media.bluestonepim.com/5eba97c0-0f19-4ad4-9894-d14228c35fb0/63c6345d-ac1a-4531-81a9-93ce6e4d7cda/9CepXLrKIkxzJHOCav5XceaLS/syO3auyvYcDy25ORajwFdGD5S.png',
    inStock: 18,
    price: 4620,
    currency: 'NOK',
  },
  {
    id: 5,
    name: 'Fairphone 4 128GB Grey',
    alias: 'Fairphone 4 128GB Grey',
    imgUrl:
      'https://acp-media.bluestonepim.com/5eba97c0-0f19-4ad4-9894-d14228c35fb0/63c6345d-ac1a-4531-81a9-93ce6e4d7cda/9CepXLrKIkxzJHOCav5XceaLS/syO3auyvYcDy25ORajwFdGD5S.png',
    inStock: 12,
    price: 4620,
    currency: 'NOK',
  },
  {
    id: 6,
    name: 'Google Pixel 5',
    alias: 'Google Pixel 5',
    imgUrl:
      'https://acp-media.bluestonepim.com/5eba97c0-0f19-4ad4-9894-d14228c35fb0/63c6345d-ac1a-4531-81a9-93ce6e4d7cda/9CepXLrKIkxzJHOCav5XceaLS/syO3auyvYcDy25ORajwFdGD5S.png',
    inStock: 20,
    price: 5000,
    currency: 'NOK',
  },
  {
    id: 7,
    name: 'OnePlus 9',
    alias: 'OnePlus 9',
    imgUrl:
      'https://acp-media.bluestonepim.com/5eba97c0-0f19-4ad4-9894-d14228c35fb0/63c6345d-ac1a-4531-81a9-93ce6e4d7cda/9CepXLrKIkxzJHOCav5XceaLS/syO3auyvYcDy25ORajwFdGD5S.png',
    inStock: 25,
    price: 4800,
    currency: 'NOK',
  },
  {
    id: 8,
    name: 'Sony Xperia 1 III',
    alias: 'Sony Xperia 1 III',
    imgUrl:
      'https://acp-media.bluestonepim.com/5eba97c0-0f19-4ad4-9894-d14228c35fb0/63c6345d-ac1a-4531-81a9-93ce6e4d7cda/9CepXLrKIkxzJHOCav5XceaLS/syO3auyvYcDy25ORajwFdGD5S.png',
    inStock: 30,
    price: 5200,
    currency: 'NOK',
  },
  {
    id: 9,
    name: 'Nokia 8.3 5G',
    alias: 'Nokia 8.3 5G',
    imgUrl:
      'https://acp-media.bluestonepim.com/5eba97c0-0f19-4ad4-9894-d14228c35fb0/63c6345d-ac1a-4531-81a9-93ce6e4d7cda/9CepXLrKIkxzJHOCav5XceaLS/syO3auyvYcDy25ORajwFdGD5S.png',
    inStock: 22,
    price: 4500,
    currency: 'NOK',
  },
  {
    id: 10,
    name: 'Huawei P40 Pro',
    alias: 'Huawei P40 Pro',
    imgUrl:
      'https://acp-media.bluestonepim.com/5eba97c0-0f19-4ad4-9894-d14228c35fb0/63c6345d-ac1a-4531-81a9-93ce6e4d7cda/9CepXLrKIkxzJHOCav5XceaLS/syO3auyvYcDy25ORajwFdGD5S.png',
    inStock: 18,
    price: 4700,
    currency: 'NOK',
  },
  {
    id: 11,
    name: 'Xiaomi Mi 11',
    alias: 'Xiaomi Mi 11',
    imgUrl:
      'https://acp-media.bluestonepim.com/5eba97c0-0f19-4ad4-9894-d14228c35fb0/63c6345d-ac1a-4531-81a9-93ce6e4d7cda/9CepXLrKIkxzJHOCav5XceaLS/syO3auyvYcDy25ORajwFdGD5S.png',
    inStock: 28,
    price: 4900,
    currency: 'NOK',
  },
  {
    id: 12,
    name: 'Oppo Find X3 Pro',
    alias: 'Oppo Find X3 Pro',
    imgUrl:
      'https://acp-media.bluestonepim.com/5eba97c0-0f19-4ad4-9894-d14228c35fb0/63c6345d-ac1a-4531-81a9-93ce6e4d7cda/9CepXLrKIkxzJHOCav5XceaLS/syO3auyvYcDy25ORajwFdGD5S.png',
    inStock: 24,
    price: 5100,
    currency: 'NOK',
  },
  {
    id: 13,
    name: 'Asus ROG Phone 5',
    alias: 'Asus ROG Phone 5',
    imgUrl:
      'https://acp-media.bluestonepim.com/5eba97c0-0f19-4ad4-9894-d14228c35fb0/63c6345d-ac1a-4531-81a9-93ce6e4d7cda/9CepXLrKIkxzJHOCav5XceaLS/syO3auyvYcDy25ORajwFdGD5S.png',
    inStock: 15,
    price: 5300,
    currency: 'NOK',
  },
  {
    id: 14,
    name: 'Motorola Edge 20 Pro',
    alias: 'Motorola Edge 20 Pro',
    imgUrl:
      'https://acp-media.bluestonepim.com/5eba97c0-0f19-4ad4-9894-d14228c35fb0/63c6345d-ac1a-4531-81a9-93ce6e4d7cda/9CepXLrKIkxzJHOCav5XceaLS/syO3auyvYcDy25ORajwFdGD5S.png',
    inStock: 19,
    price: 4600,
    currency: 'NOK',
  },
  {
    id: 15,
    name: 'LG Wing',
    alias: 'LG Wing',
    imgUrl:
      'https://acp-media.bluestonepim.com/5eba97c0-0f19-4ad4-9894-d14228c35fb0/63c6345d-ac1a-4531-81a9-93ce6e4d7cda/9CepXLrKIkxzJHOCav5XceaLS/syO3auyvYcDy25ORajwFdGD5S.png',
    inStock: 12,
    price: 5400,
    currency: 'NOK',
  },
]
